import { createSlice } from "@reduxjs/toolkit";
import {
  comparePackages,
  fetchActivePackages,
  fetchPackageDetails,
  searchPackages,
} from "../actions/packageActions";

const initialState = {
  packages: {
    loading: false,
    error: null,
    data: [],
  },
  selectedPackage: {
    loading: false,
    error: null,
    data: null,
  },
  searchResults: {
    loading: false,
    error: null,
    data: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 100,
  },
  comparison: {
    loading: false,
    error: null,
    data: null,
  },
};

const packageSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    clearSelectedPackage: (state) => {
      state.selectedPackage.data = null;
      state.selectedPackage.error = null;
    },
    clearComparison: (state) => {
      state.comparison.data = null;
      state.comparison.error = null;
    },
    clearSearchResults: (state) => {
      state.searchResults.data = [];
      state.searchResults.error = null;
      state.searchResults.totalCount = 0;
    },
  },
  extraReducers: {
    // Get Active Packages
    [fetchActivePackages.pending]: (state) => {
      state.packages.loading = true;
      state.packages.error = null;
    },
    [fetchActivePackages.fulfilled]: (state, action) => {
      state.packages.loading = false;
      state.packages.data = action.payload.data || [];
    },
    [fetchActivePackages.rejected]: (state, action) => {
      state.packages.loading = false;
      state.packages.error = action.payload;
    },

    // Get Package Details
    [fetchPackageDetails.pending]: (state) => {
      state.selectedPackage.loading = true;
      state.selectedPackage.error = null;
    },
    [fetchPackageDetails.fulfilled]: (state, action) => {
      state.selectedPackage.loading = false;
      state.selectedPackage.data = action.payload.data;
    },
    [fetchPackageDetails.rejected]: (state, action) => {
      state.selectedPackage.loading = false;
      state.selectedPackage.error = action.payload;
    },

    // Search Packages
    [searchPackages.pending]: (state) => {
      state.searchResults.loading = true;
      state.searchResults.error = null;
    },
    [searchPackages.fulfilled]: (state, action) => {
      state.searchResults.loading = false;
      state.searchResults.data = action.payload.data?.items || [];
      state.searchResults.totalCount = action.payload.data?.totalCount || 0;
      state.searchResults.pageNumber = action.payload.data?.pageNumber || 1;
      state.searchResults.pageSize = action.payload.data?.pageSize || 10;
    },
    [searchPackages.rejected]: (state, action) => {
      state.searchResults.loading = false;
      state.searchResults.error = action.payload;
    },

    // Compare Packages
    [comparePackages.pending]: (state) => {
      state.comparison.loading = true;
      state.comparison.error = null;
    },
    [comparePackages.fulfilled]: (state, action) => {
      state.comparison.loading = false;
      state.comparison.data = action.payload.data;
    },
    [comparePackages.rejected]: (state, action) => {
      state.comparison.loading = false;
      state.comparison.error = action.payload;
    },
  },
});

export const { clearSelectedPackage, clearComparison, clearSearchResults } =
  packageSlice.actions;

export default packageSlice.reducer;
